import React, { useEffect, useState } from "react";

import styles from './genresListPage.module.css'
import { apiUrls } from "../../assets/api/apiURL";
import { Link, useLocation, useParams, useHistory } from "react-router-dom";
import translation from "../../Components/Helpers/translation";
import { LoaderPage } from "../../Components/LoaderPage/loaderPage";
import Footer from "../Footer/footer";
import slug from "slug";
import SelectInput from "../../Components/Inputs/SelectInput/selectInput";
import DataInput from "../../Components/Inputs/DataInput/dataInput";
import MultiSelect from "../../Components/Inputs/MultiSelect/multiSelect";
import queryString from "query-string";
import { createLink, createParamsLink, sortAsc, sortDesc } from "../../Components/Helpers/functions";
import MobileFiltersWrapper from "../../Components/MobileFiltersWrapper/mobileFiltersWrapper";
import useWindowSize from "../../Components/Helpers/hooks/useWindowSize";
import SeoHeader from "../../Components/SeoHeader/seoHeader";

function TopFilters(props) {
    return (
        <div className={styles.top}>
            <div className={styles.row}>
                <h2 className={styles.title}>{translation.all.genresTitle}</h2>
                <div className={styles.alphabetWrapper}>
                    <ul className={styles.alphabetList}>
                        {props.alphabet.map((letter, index) => (
                            <li key={index} className={styles.alphabetItem}>
                                <button onClick={() => props.handleLetterClick(letter)}>{letter}</button>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <button type={"button"} className={styles.showButton} onClick={() => props.handleShowAll()}>{translation.all.showAll}</button>
            <div className={styles.row}>
                <div className={styles.compositorWrapper}>
                    <MultiSelect data={props.composers} search={true} selected={props.selectedComposers} setSelected={props.setSelectedComposers} placeholder={translation.all.genresForCompositor} />
                </div>
                <div className={styles.year}>
                    <DataInput data={props.years} search={true} type={"year_start"} />
                </div>
                <div className={styles.year}>
                    <DataInput data={props.years} search={true} type={"year_end"} />
                </div>
                <div className={styles.sort}>
                    <SelectInput search={true} type={"orderby"} data={translation.genresListPage.sortData} />
                </div>
            </div>
        </div>
    )
}

function GenresListPage() {

    const { lang } = useParams()
    const location = useLocation()
    const history = useHistory()
    const queryParams = queryString.parse(location.search, { arrayFormat: 'comma' })
    const [data, setData] = useState(null)
    const [alphabet, setAlphabet] = useState(null)
    const [composers, setComposers] = useState(null)
    const [years, setYears] = useState(null)
    const [loading, setLoading] = useState(false)

    const [selectedComposers, setSelectedComposers] = useState(queryParams["ids_composers[]"] !== undefined ? Array.isArray(queryParams["ids_composers[]"]) ? queryParams["ids_composers[]"] : [queryParams["ids_composers[]"]] : [])

    const size = useWindowSize()

    const createSearchToLink = () => {
        const query = queryString.parse(location.search, { arrayFormat: 'comma' })

        return createLink(query, '', 'orderby')
    }

    const handleLetterClick = (letter) => {
        const query = queryString.parse(location.search, { arrayFormat: 'comma' })
        query['letter'] = letter.toLowerCase()
        const search = queryString.stringify(query, { arrayFormat: 'comma' })
        history.push({ search })
    }

    const handleShowAll = () => {
        const query = queryString.parse(location.search, { arrayFormat: 'comma' })
        delete query['letter']

        const search = queryString.stringify(query, { arrayFormat: 'comma' })
        history.push({ search })
    }

    useEffect(() => {
        setLoading(true)
        const query = queryString.parse(location.search, { arrayFormat: 'comma' })

        setSelectedComposers(() => {
            return query["ids_composers[]"] !== undefined ? Array.isArray(query["ids_composers[]"]) ? query["ids_composers[]"] : [query["ids_composers[]"]] : []
        })

        const searchParams = createParamsLink(query, '&')

        fetch(`${apiUrls.mainUrl}${apiUrls.compositions.main}${apiUrls.compositions.genres}?lang=${lang}${searchParams}`)
            .then((res) => res.json())
            .then((json) => {
                const query = queryString.parse(location.search, { arrayFormat: 'comma' })

                let tmp = json

                if (query['letter']) {
                    tmp = tmp.filter((item) => item.name.toLowerCase().startsWith(query['letter']))
                }

                if (query['orderby']) {
                    switch (query['orderby']) {
                        case '1':
                            tmp = tmp.sort((a, b) => { return sortAsc(a.name, b.name) })
                            break;
                        case '2':
                            tmp = tmp.sort((a, b) => { return sortDesc(a.name, b.name) })
                            break;
                        default:
                            tmp = tmp.sort((a, b) => { return sortAsc(a.name, b.name) })
                    }
                }

                setData(tmp)

                setTimeout(() => {
                    setLoading(false)
                }, 200)
            })
    }, [lang, location]);

    useEffect(() => {
        fetch(`${apiUrls.mainUrl}${apiUrls.compositions.main}${apiUrls.compositions.genres}?lang=${lang}`)
            .then((res) => res.json())
            .then((json) => {
                const letters = [...new Set(json.map(item => item.name.charAt(0).toLowerCase()))]
                setAlphabet(letters)
            })
    }, [lang]);

    useEffect(() => {
        fetch(`${apiUrls.mainUrl}${apiUrls.compositions.main}${apiUrls.compositions.composers}?lang=${lang}`)
            .then((res) => res.json())
            .then((json) => {
                json.unshift({ id: null, name: translation.all.allComposers })
                setComposers(json)
            })
    }, [lang]);

    useEffect(() => {
        fetch(`${apiUrls.mainUrl}${apiUrls.compositions.main}${apiUrls.compositions.years}?lang=${lang}`)
            .then((res) => res.json())
            .then((json) => {
                json.pop()
                let tmp = []
                json.forEach((item) => {
                    tmp.push({ id: item, name: item })
                })
                setYears(tmp)
            })
    }, [lang]);

    return (
        <>
            <SeoHeader
                title={`${translation.seo.titles.siteTitle.genres} - ${translation.seo.titles.mainTitle}`}
                description={`${translation.seo.description.mainDescription}`}
            />
            <LoaderPage data={data !== null && alphabet !== null && composers && years} />
            {data && alphabet && composers && years ?
                <div className={styles.wrapper}>
                    <main>
                        <div className={styles.container}>
                            {size.width > 650
                                ? <TopFilters queryParams={queryParams} years={years} composers={composers} selectedComposers={selectedComposers} handleLetterClick={handleLetterClick} setSelectedComposers={setSelectedComposers} alphabet={alphabet} handleShowAll={handleShowAll} />
                                : <MobileFiltersWrapper>
                                    <TopFilters queryParams={queryParams} years={years} composers={composers} selectedComposers={selectedComposers} handleLetterClick={handleLetterClick} setSelectedComposers={setSelectedComposers} alphabet={alphabet} handleShowAll={handleShowAll} />
                                </MobileFiltersWrapper>
                            }
                            <div className={`${styles.listWrapper} ${loading ? styles.blur : ''}`}>
                                {data.map((item, index) => {
                                    return (
                                        <Link to={{ pathname: `/${lang}/gatunki/${item.id}-${slug(item.name)}`, state: { from: `${location.pathname}${location.search}` }, search: createSearchToLink() }} key={index} className={styles.item}>
                                            {item.name}
                                        </Link>
                                    )
                                })}

                            </div>
                            {data.length === 0
                                ? <p className={styles.empty}>{translation.all.empty}</p>
                                : null
                            }
                        </div>
                    </main>
                    <Footer />
                </div>
                : null
            }
        </>
    )
}

export default GenresListPage